// extracted by mini-css-extract-plugin
export default {"outlet_wrapper":"ProtectedLayout_outlet_wrapper__MKCw6"};